import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  useLocation,
  useParams
} from "react-router-dom"
import { map, filter, find } from 'lodash'
import { useQuery } from "@apollo/client"

import { QUERY_SITE_DATA } from './data/services/graphqlQueries'
import Home from './pages/Home'
import About from './pages/About'
import Bio from './pages/Bio'
import Appointments from './pages/Appointments'
import Contact from './pages/Contact'
import Locations from './pages/Locations'
import Services from './pages/Services'
import Service from './pages/Service'
import NotFound from './pages/404'
import PayBill from './pages/PayBill'
import Patients from './pages/Patients'
import Loading from './components/Loading'
import OrderContacts from './pages/OrderContacts'

export default () => {
  const { loading, error, data } = useQuery(QUERY_SITE_DATA, {
    notifyOnNetworkStatusChange: true
  })

  if (loading) {
    return <Loading />
  }

  const doctors = filter(data.bios, (b) => {
    return b.category === 'doctor'
  })

  const staff = filter(data.bios, (b) => {
    return b.category === 'staff'
  })

  return (
    <BrowserRouter>
      <Routes>
        {
          map(data.clinics, (clinic, index) => {
            return (
              <React.Fragment key={`clinic-${index}`}>
                <Route
                  path={clinic.url}
                  element={<Home globalData={data} clinic={clinic}/>} 
                  key={`clinic-${index}-home`}
                />
                <Route
                  path={`${clinic.url}/about`}
                  element={<About globalData={data} clinic={clinic}/>} 
                  key={`clinic-${index}-about`}
                />
                <Route
                  path={`${clinic.url}/appointments`}
                  element={<Appointments globalData={data} clinic={clinic}/>} 
                  key={`clinic-${index}-appointments`}
                />
                <Route
                  path={`${clinic.url}/services`}
                  element={<Services globalData={data} clinic={clinic}/>} 
                  key={`clinic-${index}-services`}
                />
                <Route
                  path={`${clinic.url}/contact`}
                  element={<Contact globalData={data} clinic={clinic}/>} 
                />
                <Route
                  path={`${clinic.url}/pay-bill`}
                  element={<PayBill globalData={data} clinic={clinic}/>} 
                />
                <Route
                  path={`${clinic.url}/patients`}
                  element={<Patients globalData={data} clinic={clinic}/>} 
                />
              </React.Fragment>
            )
          })
        }
        <Route path='/pay-bill' element={<PayBill globalData={data} />} />
        {
          map(data.services, (s, index) => {
            const _servicePath = `${s.clinic ? `${s.clinic}/` : '/'}services/${s.slug}`

            return <Route
              path={_servicePath}
              element={<Service globalData={data} slug={s.slug} clinic={s.clinic} />}
              key={`service-route-${index}`}
            />
          })
        }
        {
          map(doctors, (s, index) => {
            return <Route
              path={`/doctor/${s.slug}`}
              element={<Bio globalData={data} slug={s.slug} category={s.category} />}
              key={`doctor-route-${index}`}
            />
          })
        }
        {
          map(staff, (s, index) => {
            return <Route
              path={`/staff/${s.slug}`}
              element={<Bio globalData={data} slug={s.slug} category={s.category} />}
              key={`staff-route-${index}`}
            />
          })
        }
        <Route
          path="/about"
          element={<About globalData={data} />}
        />
        <Route
          path="/appointments"
          element={<Appointments globalData={data} />}
        />
        <Route
          path="/order-contacts"
          element={<OrderContacts globalData={data} />}
        />
        <Route
          path="/contact"
          element={<Contact globalData={data} />}
        />
        <Route
          path="/services"
          element={<Services globalData={data} />}
        />
        <Route
          path="/locations"
          element={<Locations globalData={data} />}
        />
        <Route
          path="/patients"
          element={<Patients globalData={data} />}
        />
        <Route
          path="/"
          element={<Home globalData={data} />} 
        />
        <Route
          path="*"
          element={<NotFound globalData={data} />} 
        />
      </Routes>
    </BrowserRouter>
  )
}